import { useMemo } from "react";
import { useAuth } from "./AuthContext";

export type SimpleUser = { uid: string; email?: string | null; displayName?: string | null } | null;

/**
 * Returns a simplified user object derived from AuthContext.
 * Drop-in replacement for the old Zustand useUser() selector.
 */
export function useUser(): SimpleUser {
    const { user } = useAuth();
    return useMemo(
        () => (user ? { uid: user.uid, email: user.email, displayName: user.displayName } : null),
        [user]
    );
}
